export const useGetDrinkTypes = () => {
  return [
    { key: "Piva", name: "Pivo", icon: "beer.svg" },
    { key: "Rum", name: "Rum", icon: "384.svg" },
    { key: "Vodka", name: "Vodka", icon: "vodka.svg" },
    { key: "Whiskey", name: "Whisky", icon: "48.svg" },
    { key: "Likér", name: "Likér", icon: "jagermeister.svg" },
    { key: "Vína", name: "Víno", icon: "19197.svg" },
    { key: "Nealkoholické nápoje", name: "Nealko", icon: "178.svg" },
    { key: "Ostatní", name: "Ostatní", icon: "243.svg" },
  ];
};
